import axios from 'axios';
import userManager from './utils/userManager';
import {leerplatformSettingsStore} from './stores/leerplatformSettingsStore';

// Function to initialize axios client
async function createClient() {
    const {apiUrl} = await leerplatformSettingsStore.loadEnvironmentConfig();

    const client = axios.create({
        baseURL: apiUrl,
    });

    client.interceptors.request.use(
        async (config) => {
            const user = await userManager.getUser();

            config.headers.Authorization = `Bearer ${user.access_token}`;
            return config;
        },
        (error) => Promise.reject(error),
    );

    return client;
}

const clientPromise = await createClient();

export default clientPromise;
